// frontend/src/components/Mobile/mobileMenu.js
//
// Single source of truth for the mobile app's menu. Each entry is tied to a
// core.menu_items / core.group_permissions menu_key, exactly like the desktop
// menu — the bottom nav, the route guard and the post-login redirect all read
// this list, so adding a screen to the mobile app = one entry here + one
// <Route> in App.js + one row in menu_mobile.sql.
//
// `group` is the app area (FastReact, later Cutting, Quality, …). The bottom
// nav shows only the entries the user can read; groups are for the SQL/menu
// admin screen and for future grouping if the nav grows.

import { FiList, FiPackage, FiRepeat, FiLayers } from 'react-icons/fi';

export const MOBILE_MENU = [
  {
    key: 'mobile_fastreact_plano_teares',
    group: 'FastReact',
    path: '/mobile/plano-teares',
    label: 'Plano Teares',
    icon: FiList,
  },
  {
    key: 'mobile_fastreact_pickup',
    group: 'FastReact',
    path: '/mobile/pickup',
    label: 'Recolha',
    icon: FiPackage,
  },
  {
    key: 'mobile_fastreact_restock',
    group: 'FastReact',
    path: '/mobile/restock',
    label: 'Reabastecer',
    icon: FiRepeat,
  },
  {
    key: 'mobile_fastreact_restock_groups',
    group: 'FastReact',
    path: '/mobile/restock-groups',
    label: 'Reabastecer (Agrupado)',
    icon: FiLayers,
  },
];

/** Menu entries the user may open (can read). */
export const allowedMobileMenu = (can) => MOBILE_MENU.filter((m) => can(m.key, 'read'));

/** First screen the user is allowed into — landing page / redirect target. */
export const firstAllowedMobilePath = (can) => allowedMobileMenu(can)[0]?.path || null;

/** Top-level screens (no back button) = every menu entry's own path. */
export const isMobileHomePath = (pathname) =>
  pathname === '/mobile' || MOBILE_MENU.some((m) => m.path === pathname);